module.exports = __webpack_public_path__ + "img/tic-tac-meu-primeiro-livro.f5c470d5.png";